























import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'SidebarCustomButton'
})
export default class extends Vue {
  @Prop({ required: true }) private text!: string
  @Prop({ required: true }) private icon!: string
  @Prop({ default: false }) private isCollapse!: boolean
  @Prop({ default: () => {} }) public onClick!: Function
}
